import { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from '../layout/Sidebar';
import Navbar from '../layout/Navbar';
import { useLocation } from 'react-router-dom';
import { stockMenuItems } from '../../pages/StokFlow'; // Stok Takip menü öğelerini içe aktar

// Stok Sistemi için özel layout
const StokLayout = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  // Mobil görünümde sayfa değiştiğinde sidebar'ı kapat
  useEffect(() => {
    setIsOpen(false);
  }, [location.pathname]);

  // Sistemin Stok Takip olduğundan emin ol
  useEffect(() => {
    // Aktif paneli stok olarak ayarla (localStorage)
    localStorage.setItem('activePanel', 'stock');
  }, []);

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      <Sidebar 
        isOpen={isOpen} 
        onToggle={() => setIsOpen(!isOpen)} 
        customMenuItems={stockMenuItems} 
        isStockPanel={true} 
      />
      
      {/* Main Content - Use lg:pl-72 to prevent content from going behind navbar */}
      <div className={`lg:pl-72 transition-all duration-300 ease-in-out ${isOpen ? 'lg:pl-72' : 'lg:pl-0'}`}>
        <Navbar onToggleSidebar={() => setIsOpen(!isOpen)} isStockPanel={true} />
        
        <main className="py-6 px-4 sm:px-6 lg:px-8">
          {children || <Outlet />}
        </main>
      </div>
    </div>
  );
};

export default StokLayout; 